// GENERATED by scripts/build-icons.mjs from icons/archive.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Archive = createIcon('archive', [
  ['rect', { width: "20", height: "5", x: "2", y: "3", rx: "1" }],
  ['path', { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" }],
  ['path', { d: "M10 12h4" }],
])
